import * as React from "react"
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icon,
} from "@nexus/ui"
import { useTranslation } from "react-i18next"

export interface RevertScriptDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  scriptTitle: string | null
  isReverting: boolean
  onConfirm: () => void
}

export function RevertScriptDialog({
  open,
  onOpenChange,
  scriptTitle,
  isReverting,
  onConfirm,
}: RevertScriptDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!isReverting) onOpenChange(v) }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-destructive/10">
            <Icon name="refresh-cw" size="sm" className="text-destructive" />
          </div>
          <DialogTitle className="text-base">
            {t("opportunities.scripts.revert.confirmTitle")}
          </DialogTitle>
          <DialogDescription>
            {t("opportunities.scripts.revert.confirmDescription")}
          </DialogDescription>
        </DialogHeader>

        {scriptTitle && (
          <div className="rounded-lg border border-border bg-muted/30 px-3 py-2.5">
            <p className="line-clamp-2 text-sm font-medium leading-snug text-foreground">
              {scriptTitle}
            </p>
          </div>
        )}

        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onOpenChange(false)}
            disabled={isReverting}
          >
            {t("common.cancel")}
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={onConfirm}
            disabled={isReverting}
            iconStart={isReverting ? "loader" : "refresh-cw"}
            className={isReverting ? "[&_svg]:animate-spin" : ""}
          >
            {t("opportunities.scripts.revert.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
